export default __webpack_public_path__ + "static/bunfestival-2-f43dcb77ec9fec5c293efac1a731a186.png";